import { useEffect, useState } from 'react';
import { isIPad13, isMobile } from 'mobile-device-detect';

export const useDeviceOrientation = () => {
    const [isLandscape, setIsLandscape] = useState(
        () => window.matchMedia('(orientation: landscape)').matches && isMobile && !isIPad13,
    );

    useEffect(() => {
        const updateOrientation = () => {
            setIsLandscape(
                window.matchMedia('(orientation: landscape)').matches && isMobile && !isIPad13,
            );
        };

        window.addEventListener('resize', updateOrientation);

        return () => {
            window.removeEventListener('resize', updateOrientation);
        };
    }, []);

    return { isLandscape };
};
